import { render, staticRenderFns } from "./LegacyHelp.vue?vue&type=template&id=3a91207a&"
import script from "./LegacyHelp.vue?vue&type=script&lang=js&"
export * from "./LegacyHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports